module.exports = __webpack_public_path__ + "static/media/guest.79f51b19.png";